let carPageUrl = "https://www.ebcbrakeshop.co.uk/pages/car-search";
let bikePageUrl = "https://www.ebcbrakeshop.co.uk/pages/bike-search";

// Delivery timer
document.addEventListener("DOMContentLoaded", () => {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th";

    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  function isHoliday(date) {
    // Add UK closure dates here in YYYY-MM-DD format.
    const holidays = [
      // "2026-12-25",
      // "2026-12-28",
    ];

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");

    return holidays.includes(`${year}-${month}-${day}`);
  }

  function getUKNowAsUtcDate() {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    });

    const parts = formatter.formatToParts(now);

    const getPart = (type) =>
      Number(parts.find((part) => part.type === type).value);

    return new Date(
      Date.UTC(
        getPart("year"),
        getPart("month") - 1,
        getPart("day"),
        getPart("hour"),
        getPart("minute"),
        getPart("second"),
      ),
    );
  }

  function isWorkingDay(date) {
    const day = date.getUTCDay();

    return day !== 0 && day !== 6 && !isHoliday(date);
  }

  function getNextWorkingDay(date) {
    const nextDay = new Date(date.getTime());

    do {
      nextDay.setUTCDate(nextDay.getUTCDate() + 1);
    } while (!isWorkingDay(nextDay));

    return nextDay;
  }

  function getCutoffForDate(date) {
    const cutoff = new Date(date.getTime());
    const day = cutoff.getUTCDay();

    cutoff.setUTCMilliseconds(0);

    if (day === 5) {
      // Friday cutoff: 10:30am
      cutoff.setUTCHours(10, 30, 0, 0);
    } else {
      // Monday–Thursday cutoff: 12pm
      cutoff.setUTCHours(12, 0, 0, 0);
    }

    return cutoff;
  }

  function getNextAvailableCutoff(now) {
    let cutoffDate = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        0,
        0,
        0,
        0,
      ),
    );

    /*
     * Find the next working-day cutoff that has not passed.
     *
     * Monday–Thursday: 12pm
     * Friday: 10:30am
     * Saturday/Sunday: closed
     */
    while (true) {
      if (isWorkingDay(cutoffDate)) {
        const cutoff = getCutoffForDate(cutoffDate);

        if (cutoff.getTime() > now.getTime()) {
          return cutoff;
        }
      }

      cutoffDate.setUTCDate(cutoffDate.getUTCDate() + 1);
    }
  }

  function getDeliveryDateFromCutoff(cutoff) {
    /*
     * Orders placed before a valid cutoff are delivered on the
     * next working day.
     *
     * Friday cutoff therefore gives Monday delivery.
     */
    return getNextWorkingDay(cutoff);
  }

  function getMonthName(date) {
    const safeDate = new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        12,
        0,
        0,
      ),
    );

    return new Intl.DateTimeFormat("en-GB", {
      month: "short",
      timeZone: "UTC",
    }).format(safeDate);
  }

  function updateCountdown() {
    const now = getUKNowAsUtcDate();
    const targetTime = getNextAvailableCutoff(now);
    const deliveryDay = getDeliveryDateFromCutoff(targetTime);

    const dayName = daysOfWeek[deliveryDay.getUTCDay()];
    const dateNumber = deliveryDay.getUTCDate();
    const dateWithSuffix =
      dateNumber + getOrdinalSuffix(dateNumber);
    const monthName = getMonthName(deliveryDay);

    document.querySelectorAll(".dispatch-text").forEach((element) => {
      element.innerHTML =
        `for delivery ${dayName} ${dateWithSuffix} ${monthName}`;
    });

    const difference = Math.max(
      0,
      targetTime.getTime() - now.getTime(),
    );

    const hours = Math.floor(difference / 3600000);
    const minutes = Math.floor(
      (difference % 3600000) / 60000,
    );
    const seconds = Math.floor(
      (difference % 60000) / 1000,
    );

    document.querySelectorAll(".countdown-timer").forEach((element) => {
      element.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});

function updateCartBubble() {
    fetch(`/?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCartBubbleContent =
                doc.querySelector(".shopify-section").innerHTML;
            document.querySelector("#cart-icon-bubble").innerHTML =
                newCartBubbleContent;
        })
        .catch((err) => console.error("Failed to update cart bubble:", err));
}

function escapeCSS(id) {
    return id.replace(/([^\w-])/g, "\\$1");
}

const updateCartDrawer = async () => {
    await updateDrawer();
    openDrawer();
};

const updateDrawer = async () => {
    try {
        const response = await fetch(`/cart?sections=cart-drawer`);
        const text = await response.text();
        const json = JSON.parse(text);

        const html = json["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newCartDrawerContent =
            doc.querySelector("cart-drawer").innerHTML;

        const drawer = document.querySelector("cart-drawer");

        drawer.innerHTML = newCartDrawerContent;
        drawer.classList.remove("is-empty");

    } catch (err) {
        console.error("Failed to update cart drawer:", err);
    }
};

const openDrawer = () => {
    const drawer = document.querySelector("cart-drawer");
    drawer && drawer.open();
};

function removeFilter(event) {
    let parentDiv = event.target.closest("div");
    let content = parentDiv.childNodes[0].textContent;
    let customFilterArr = document.querySelectorAll(".customFilter input");
    let result = Array.from(customFilterArr).filter(
        (element) => element.value.trim() == content.trim(),
    );
    result.forEach((element) => {
        element.checked = false;
        element.dispatchEvent(new Event("change"));
    });
    parentDiv.remove();
}

//-------- add to cart--------------//
function addToCart(variantId, event) {
    event.target.disabled = true;
    event.target.classList.add("loadingCart");
    event.target.nextElementSibling.classList.remove("hidden");
    let select = document.querySelector(`#quantitySelect_${variantId}`);
    let quantity = select.value;
    fetch(`/cart/add.js`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json(); // This parses the JSON body of the response
        })
        .then((data) => {

            // drawer logic while click on collection page add-to-cart button.
            updateCartDrawer();
            updateCartBubble();

            event.target.disabled = false;
            event.target.classList.remove("loadingCart");
            event.target.nextElementSibling.classList.add("hidden");
        })
        .catch((error) => {
            console.error("Error adding item to cart:", error.message);
        });
}
